//#. Vuex Type Script
//#. Version		          : 1.0.0.0
//#. Template Modified Date : 12-MAR-2020 10:00:00 AM
//#. File Created Date      : 12-MAR-2020 10:00:00 AM
import { Module } from "vuex";
import { RootState } from "../../../../types";
import { EditProfile } from "./types";
import { getters } from './getters';
import { mutations } from "./mutations";
import { actions } from "./actions";
const namespaced: boolean = true;

//#. An object containing the data
export const state: EditProfile = {
    container: true,
    content: [
        {
            icon: 'mdi-account-edit',
            fontSize: '20',
            title: 'Edit Profile',
            color: '',
            name: 'edit'
        },
        // {
        //     icon: 'mdi-translate',
        //     fontSize: '20',
        //     title: 'Language',
        //     color: '',
        //     name: 'language'
        // }
    ],
    defaultLanguages: 'en',
    languages: [
        { key: 'English', value: 'en' },
        { key: 'Spanish', value: 'es' },
        { key: 'French ', value: 'fr' }
    ],
    signOut: 'Sign Out',
    user: {
        name: '',
        email: '',
        avatar: '',
        acronym: '',
        date: ''
    }
};

export const RootEditProfile: Module<EditProfile, RootState> = {
    namespaced,
    state,
    getters,
    mutations,
    actions,
};